import AI4BHARAT_ICON_FILE from './vendor-icons/ai4bharat.svg';
import AISINGAPORE_ICON_FILE from './vendor-icons/aisingapore.svg';
import ANTHROPIC_ICON_FILE from './vendor-icons/anthropic.svg';
import BAAI_ICON_FILE from './vendor-icons/baai.svg';
import BLACK_FOREST_LABS_ICON_FILE from './vendor-icons/blackforestlabs.svg';
import BYTEDANCE_ICON_FILE from './vendor-icons/bytedance.svg';
import COHERE_ICON_FILE from './vendor-icons/cohere.svg';
import DEEPGRAM_ICON_FILE from './vendor-icons/deepgram.svg';
import DEEPSEEK_ICON_FILE from './vendor-icons/deepseek.svg';
import DEFOG_ICON_FILE from './vendor-icons/defog.svg';
import EXAONE_ICON_FILE from './vendor-icons/exaone.svg';
import FBLGIT_ICON_FILE from './vendor-icons/fblgit.svg';
import GOOGLE_ICON_FILE from './vendor-icons/google.svg';
import HUGGINGFACE_ICON_FILE from './vendor-icons/huggingface.svg';
import IBM_ICON_FILE from './vendor-icons/ibm.svg';
import LEONARDO_ICON_FILE from './vendor-icons/leonardo.svg';
import LLAVA_HF_ICON_FILE from './vendor-icons/llava-hf.svg';
import LYKON_ICON_FILE from './vendor-icons/lykon.svg';
import META_ICON_FILE from './vendor-icons/meta.svg';
import MICROSOFT_ICON_FILE from './vendor-icons/microsoft.svg';
import MINIMAX_ICON_FILE from './vendor-icons/minimax.svg';
import MISTRALAI_ICON_FILE from './vendor-icons/mistralai.svg';
import MOONSHOTAI_ICON_FILE from './vendor-icons/moonshotai.svg';
import MYSHELL_AI_ICON_FILE from './vendor-icons/myshell-ai.svg';
import NVIDIA_ICON_FILE from './vendor-icons/nvidia.svg';
import OPENAI_ICON_FILE from './vendor-icons/openai.svg';
import OPENCHAT_ICON_FILE from './vendor-icons/openchat.svg';
import OPENROUTER_ICON_FILE from './vendor-icons/openrouter.svg';
import PERPLEXITY_ICON_FILE from './vendor-icons/perplexity.svg';
import PFNET_ICON_FILE from './vendor-icons/pfnet.svg';
import PIPECAT_AI_ICON_FILE from './vendor-icons/pipecat-ai.svg';
import QWEN_ICON_FILE from './vendor-icons/qwen.svg';
import RUNWAYML_ICON_FILE from './vendor-icons/runwayml.svg';
import STABILITY_AI_ICON_FILE from './vendor-icons/stabilityai.svg';
import THEBLOKE_ICON_FILE from './vendor-icons/thebloke.svg';
import TIIUAE_ICON_FILE from './vendor-icons/tiiuae.svg';
import TINYLLAMA_ICON_FILE from './vendor-icons/tinyllama.svg';
import UNUM_ICON_FILE from './vendor-icons/unum.svg';
import XAI_ICON_FILE from './vendor-icons/xai.svg';
import ZAI_ORG_ICON_FILE from './vendor-icons/zai-org.svg';

export const NOVITA_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" role="img" aria-label="Novita AI">
  <rect width="48" height="48" rx="10" fill="#F7F8FA"/>
  <g transform="translate(7 13.35) scale(1.4167)">
    <path d="M24 14.8323V14.8326H14.3246L9.16716 9.67507V14.8326H0V14.8314L9.16716 5.66422V0H9.16774L24 14.8323Z" fill="#050505"/>
  </g>
</svg>`;

const OPENROUTER_LAB_ICONS: Record<string, string> = {
  anthropic: ANTHROPIC_ICON_FILE,
  google: GOOGLE_ICON_FILE,
  'google-ai': GOOGLE_ICON_FILE,
  meta: META_ICON_FILE,
  'meta-llama': META_ICON_FILE,
  nvidia: NVIDIA_ICON_FILE,
  alibaba: QWEN_ICON_FILE,
  deepseek: DEEPSEEK_ICON_FILE,
  'deepseek-ai': DEEPSEEK_ICON_FILE,
  qwen: QWEN_ICON_FILE,
  minimax: MINIMAX_ICON_FILE,
  moonshotai: MOONSHOTAI_ICON_FILE,
  moonshot: MOONSHOTAI_ICON_FILE,
  'x-ai': XAI_ICON_FILE,
  xai: XAI_ICON_FILE,
  'z-ai': ZAI_ORG_ICON_FILE,
  'zai-org': ZAI_ORG_ICON_FILE,
  zai: ZAI_ORG_ICON_FILE,
  zhipu: ZAI_ORG_ICON_FILE,
  exaone: EXAONE_ICON_FILE,
  lgai: EXAONE_ICON_FILE,
  openrouter: OPENROUTER_ICON_FILE,
  openai: OPENAI_ICON_FILE,
  'openai-sdk': OPENAI_ICON_FILE,
  mistral: MISTRALAI_ICON_FILE,
  mistralai: MISTRALAI_ICON_FILE,
  cohere: COHERE_ICON_FILE,
  perplexity: PERPLEXITY_ICON_FILE,
};

const COPIED_OPENROUTER_VENDOR_ICONS: Record<string, string> = {
  ai4bharat: AI4BHARAT_ICON_FILE,
  aisingapore: AISINGAPORE_ICON_FILE,
  baai: BAAI_ICON_FILE,
  'black-forest-labs': BLACK_FOREST_LABS_ICON_FILE,
  blackforestlabs: BLACK_FOREST_LABS_ICON_FILE,
  bfl: BLACK_FOREST_LABS_ICON_FILE,
  bytedance: BYTEDANCE_ICON_FILE,
  deepgram: DEEPGRAM_ICON_FILE,
  defog: DEFOG_ICON_FILE,
  fblgit: FBLGIT_ICON_FILE,
  google: GOOGLE_ICON_FILE,
  huggingface: HUGGINGFACE_ICON_FILE,
  'hugging-face': HUGGINGFACE_ICON_FILE,
  ibm: IBM_ICON_FILE,
  'ibm-granite': IBM_ICON_FILE,
  leonardo: LEONARDO_ICON_FILE,
  'leonardo-ai': LEONARDO_ICON_FILE,
  'llava-hf': LLAVA_HF_ICON_FILE,
  lykon: LYKON_ICON_FILE,
  microsoft: MICROSOFT_ICON_FILE,
  'myshell-ai': MYSHELL_AI_ICON_FILE,
  openchat: OPENCHAT_ICON_FILE,
  pfnet: PFNET_ICON_FILE,
  'pipecat-ai': PIPECAT_AI_ICON_FILE,
  runwayml: RUNWAYML_ICON_FILE,
  'stability-ai': STABILITY_AI_ICON_FILE,
  stabilityai: STABILITY_AI_ICON_FILE,
  thebloke: THEBLOKE_ICON_FILE,
  tiiuae: TIIUAE_ICON_FILE,
  tinyllama: TINYLLAMA_ICON_FILE,
  unum: UNUM_ICON_FILE,
};

export function svgToDataUri(svg: string): string {
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');
  return `data:image/svg+xml,${encoded}`;
}

function normalizeIcon(icon: string): string {
  if (icon.startsWith('data:') || icon.startsWith('http://') || icon.startsWith('https://')) {
    return icon;
  }
  return svgToDataUri(icon);
}

function getVendorSegment(modelId?: string): string | undefined {
  const normalized = (modelId || '').trim().toLowerCase();
  if (!normalized || !normalized.includes('/')) return undefined;
  return normalized.split('/')[0];
}

function getLabIcon(modelId?: string): string | undefined {
  const vendor = getVendorSegment(modelId);
  if (!vendor) return undefined;

  const icon = OPENROUTER_LAB_ICONS[vendor] || COPIED_OPENROUTER_VENDOR_ICONS[vendor];
  return icon ? normalizeIcon(icon) : undefined;
}

export function getNovitaIconDataUri(): string {
  return svgToDataUri(NOVITA_ICON);
}

export function getNovitaModelIconDataUri(modelId?: string): string | undefined {
  return getLabIcon(modelId);
}
